<template>
    <div class="shoppingmoney">
        <header>
            <ul class="Location FlexJCSB FlexAIC">
                <li style="visibility: hidden;"><a href="/home" class="Button BCFCB">首頁</a></li>
                <li><h3>ESG行動卡</h3></li>
                <li></li>
            </ul>
        </header>
        <section>
            <div class="OrderCompleted TextAC">
                <img src="https://shopdev.cheerlife.io/_images/CheerBaby_1.png" width="109" alt="" class="ImgA">
                <div class="txt">
                    <h4 class="TextAL">請輸入想綁定的ESG行動卡序號</h4>
                    <div class="FormBox FlexJCSB">
                        <input type="text" v-model="money_coupon">
                        <input type="button" value="使用" @click="UseMoneyCoupon">
                    </div>
                </div>
                <hr>
                <div class="txt">
                    <!-- <h4>※ 購物卡狀態 ※</h4> -->
                    <span>目前剩餘：<strong>{{ balance }}元</strong></span>
                </div>
                <div class="txt FocusStyle FlexJCSB FlexAIC" v-show="false">
                    <span class="TextAL"><small>2021/06/01</small><br>使用滿千折百</span>
                    <span>-100</span>
                </div>
                <div class="txt FocusStyle FlexJCSB FlexAIC" v-show="false">
                    <span class="TextAL"><small>2021/05/31</small><br>輸入序號</span>
                    <span>+{{balance}}</span>
                </div>
                <div class="ButtonBox">
                    <a href="/home" class="Button BCFCB" id="buy_btn" v-show="false">來去逛逛</a>
                    <a href="https://line.me/R/ti/p/%40upj2342c" class="Button BCFCA" id="add_frind_btn" v-show="false">加入Line好友</a>
                    <a @click="toBuyList" class="Button BCFCB">團購中心</a>
                </div>
            </div>
        </section>
        <!-- login -->
        <v-dialog
            v-model="dialog"
            width="500"
            persistent
        >
            <v-stepper v-model="login_info.el">
                <v-stepper-items>
                    <v-stepper-content step="1" class="ma-2">
                        <div class="mb-3">
                            <v-card-title class="headline">請輸入您的手機號碼</v-card-title>
                            <v-card-text>
                                <v-text-field
                                    v-model="login_info.mobile"
                                    type="number"
                                    label="電話"
                                ></v-text-field>
                            </v-card-text>
                        </div>
                        <v-btn
                            color="primary"
                            @click="checkUserState()"
                        >
                            下一步
                        </v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <div class="mb-3">
                        <v-card-title class="headline">請輸入簡訊驗證碼</v-card-title>
                        <v-card-text>
                            <v-text-field
                                v-model="login_info.mobile"
                                type="number"
                                label="電話"
                            ></v-text-field>
                            <div class="text-center mb-5">
                            <v-btn
                                color="error"
                                @click="SendSMSCode()"
                                :disabled="sms_btn.smsbtndisable"
                            >
                                發送手機驗證碼
                                <span
                                    class="pl-2"
                                    v-show="sms_btn.smsbtndisable"
                                >
                                    {{ sms_btn.smsCountDown }}秒
                                </span>
                            </v-btn>
                            </div>
                            <v-text-field
                                v-model="login_info.sns"
                                label="輸入簡訊中的驗證碼"
                                outlined
                            ></v-text-field>
                        </v-card-text>
                        </div>
                        <v-btn
                            color="primary"
                            @click="CheckSMSCode()"
                        >
                            確認送出
                        </v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <div class="mb-3">
                        <v-card-title class="headline">{{ set_password_tittle }}</v-card-title>
                        <v-card-subtitle>需4位以上字母</v-card-subtitle>
                        <v-card-text>
                            <v-text-field
                                :append-icon="show_area.password1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show_area.password1 ? 'text' : 'password'"
                                @click:append="show_area.password1 = !show_area.password1"
                                v-model="login_info.newpassword"
                                label="密碼"
                            ></v-text-field>
                            <v-text-field
                                :append-icon="show_area.password2 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show_area.password2 ? 'text' : 'password'"
                                @click:append="show_area.password2 = !show_area.password2"
                                v-model="login_info.checknewpassword"
                                label="確認密碼"
                            ></v-text-field>
                        </v-card-text>
                        </div>
                        <v-btn
                            color="primary"
                            @click="SendPassword()"
                        >
                            送出密碼
                        </v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <div>
                            <v-card-title class="headline">輸入手機與密碼</v-card-title>
                            <v-card-text class="mb-n5">
                                <v-text-field
                                    v-model="login_info.mobile"
                                    label="手機"
                                ></v-text-field>
                                <v-text-field
                                    :append-icon="show_area.password3 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show_area.password3 ? 'text' : 'password'"
                                    @click:append="show_area.password3 = !show_area.password3"
                                    v-model="login_info.password"
                                    label="密碼"
                                ></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="forgetPassword()">忘記密碼</v-btn>
                            </v-card-actions>
                        </div>
                        <v-btn
                            color="primary"
                            @click="SendLogin()"
                        >
                            送出
                        </v-btn>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-dialog>
        <CheerLifeFooter />
    </div>
</template>

<script>
// @ is an alias to /src
import CheerLifeFooter from '@/components/CheerLifeFooter.vue';

export default {
    name: 'shoppingmoney',
    components: {
        CheerLifeFooter,
    },
    computed: {
    },
    data: () => ({
        access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
        user_uuid: '',
        token: '',
        money_coupon: '',
        balance: 0,
        not_login: true,
        // login
        dialog: false,
        login_info: {
            el: 1,
            mobile: '',
            state: '',
            sns: '',
            resetsns: '',
            newpassword: '',
            checknewpassword: '',
            password: '',
        },
        // 簡訊按鈕倒數
        sms_btn: {
            smsCountDown: 180,
            smsbtndisable: false,
        },
        // 設定密碼文字
        set_password_tittle: '請設定密碼,作為下次登入使用',
        // show 密碼
        show_area: {
            password1: false,
            password2: false,
            password3: false,
        },
    }),
    methods: {
        toBuyList() {
            const getMobile = this.login_info.mobile;
            window.location.href = `https://${process.env.VUE_APP_BUYLIST}.cheerlife.io/product?phone=${getMobile}`;
        },
        getUserLogin() {
            //  判斷是不是從app進入
            if (navigator.userAgent.indexOf('cheerlife') !== -1) {
                const geturl = window.location.search;
                if (geturl.indexOf('phone') >= 0) {
                    this.login_info.mobile = this.$route.query.phone;
                    // login axios
                    this.axios({
                        method: 'post',
                        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/get-user-token`,
                        data: {
                            access_key: this.access_key,
                            mobile: this.login_info.mobile,
                        },
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.token = response.data.token;
                                this.user_uuid = response.data.user_uuid;
                                sessionStorage.setItem('accessToken', this.token);
                                sessionStorage.setItem('user_uuid', this.user_uuid);
                                // set cookies
                                const expire_day = 1;
                                const get_day = new Date();
                                get_day.setTime(get_day.getTime() + (expire_day * 24 * 60 * 60 * 1000));
                                const expires = `expires=${get_day.toGMTString()}`;
                                document.cookie = `accessToken=${this.token}; expires=${expires};`;
                                document.cookie = `user_uuid=${this.user_uuid}; expires=${expires};`;
                                // has login
                                this.dialog = false;
                            } else {
                                alert(response.data.message);
                                return false;
                            }
                        })
                        .catch((error) => {
                            if (error.response.status === 401) {
                                alert(error.response.data.message);
                            } else {
                                alert(`status code: ${ error.response.status }`);
                                alert(error.response.data.message);
                            }
                        });
                    // has login
                    this.dialog = false;
                } else {
                    // alert('錯誤！！取不到手機號碼');
                    // not login
                    this.dialog = true;
                }
            } else {
                if (
                    sessionStorage.getItem('accessToken') !== '' &&
                    sessionStorage.getItem('accessToken') !== null &&
                    sessionStorage.getItem('user_uuid') !== '' &&
                    sessionStorage.getItem('user_uuid') !== null
                ) {
                    this.token = sessionStorage.getItem('accessToken');
                    this.user_uuid = sessionStorage.getItem('user_uuid');
                    this.login_info.mobile = sessionStorage.getItem('mobile');
                    // has login
                    this.dialog = false;
                } else {
                    // not login
                    this.dialog = true;
                }
            }
        },
        // login
        checkUserState() {
            if (this.login_info.mobile !== '') {
                const mobile_re = /^[09]{2}[0-9]{8}$/;
                if (!mobile_re.test(this.login_info.mobile)) {
                    alert('手機格式錯誤');
                    return false;
                } else {
                    this.axios({
                        method: 'post',
                        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/check-user-register`,
                        data: {
                            access_key: this.access_key,
                            mobile: this.login_info.mobile,
                        },
                    })
                        .then((response) => {
                            // console.log(response);
                            if (response.status === 200) {
                                this.user_uuid = response.data.user_uuid;
                                this.login_info.message = response.data.message;
                                sessionStorage.setItem('mobile', this.login_info.mobile);
                                if (this.login_info.message !== 'registered') {
                                    this.SMSCountDownTimer();
                                    this.login_info.el = 2;
                                } else {
                                    this.login_info.el = 4;
                                }
                            } else {
                                alert(response.data.message);
                                return false;
                            }
                        })
                        .catch((error) => {
                            alert(`status code: ${ error.response.status }`);
                            alert(error.response.data.message);
                        });
                    }
            } else {
                alert('未填寫手機');
                return false;
            }
        },
        // 重新發送簡訊倒數
        SMSCountDownTimer() {
            if (this.sms_btn.smsCountDown > 0) {
                this.sms_btn.smsbtndisable = true;
                setTimeout(() => {
                    this.sms_btn.smsCountDown -= 1
                    this.SMSCountDownTimer();
                }, 1000)
            } else {
                this.sms_btn.smsbtndisable = false;
            }
        },
        // 發送手機認證碼
        SendSMSCode() {
            this.axios({
                method: 'post',
                url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/send-verify`,
                data: {
                    access_key: this.access_key,
                    mobile: this.login_info.mobile,
                    user_uuid: this.user_uuid,
                },
            })
                .then((response) => {
                    if (response.status === 200) {
                        alert('已發送！！');
                        this.sms_btn.smsCountDown = 180;
                        this.SMSCountDownTimer();
                    } else {
                        alert(response.data.message);
                        return false;
                    }
                })
                .catch((error) => {
                    alert(`status code: ${ error.response.status }`);
                    alert(error.response.data.message);
                });
        },
        // 驗證簡訊認證碼
        CheckSMSCode() {
            this.axios({
                method: 'post',
                url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/check-verify-code`,
                data: {
                    access_key: this.access_key,
                    mobile: this.login_info.mobile,
                    code: this.login_info.sns,
                },
            })
                .then((response) => {
                    // console.log(response);
                    if (response.status === 200) {
                        this.token = response.data.token;
                        this.login_info.el = 3;
                    } else {
                        alert(response.data.message);
                        return false;
                    }
                })
                .catch((error) => {
                    alert(`status code: ${ error.response.status }`);
                    alert(error.response.data.message);
                });
        },
        // 送出設定的密碼
        SendPassword() {
            if (this.login_info.checknewpassword === this.login_info.newpassword) {
                const password_re = /^.*(?=.{4,}).*$/;
                if (!password_re.test(this.login_info.newpassword)) {
                    alert('密碼格式錯誤');
                    return false;
                } else {
                    this.axios({
                        method: 'post',
                        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/set-password`,
                        headers: { 
                        Authorization: `Bearer ${this.token}`
                        },
                        data: {
                            user_uuid: this.user_uuid,
                            password: this.Base64.encode(this.login_info.newpassword),
                        },
                    })
                        .then((response) => {
                        // console.log(response);
                        if (response.status === 200) {
                            alert('密碼設定成功！');
                            sessionStorage.setItem('accessToken', this.token);
                            sessionStorage.setItem('user_uuid', this.user_uuid);
                            // set cookies
                            const expire_day = 1;
                            const get_day = new Date();
                            get_day.setTime(get_day.getTime() + (expire_day * 24 * 60 * 60 * 1000));
                            const expires = `expires=${get_day.toGMTString()}`;
                            document.cookie = `accessToken=${this.token}; expires=${expires};`;
                            document.cookie = `user_uuid=${this.user_uuid}; expires=${expires};`;
                            // has login
                            this.not_login = false;
                            this.getUserInfo();
                        } else {
                            alert(response.data.message);
                            return false;
                        }
                        })
                            .catch((error) => {
                            alert(`status code: ${ error.response.status }`);
                            alert(error.response.data.message);
                        });
                    }
            } else {
                alert('密碼與確認密碼不相符！！');
                return false;
            }
        },
        // 忘記密碼
        forgetPassword() {
            this.set_password_tittle = '請重新設定密碼';
            this.login_info.el = 2;
        },
        // 手機密碼登入
        SendLogin() {
            let userpassword = this.Base64.encode(`${this.login_info.mobile}:${this.login_info.password}`);
            this.axios({
                method: 'get',
                url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/login`,
                headers: { 
                Authorization: `Basic ${userpassword}`
                },
            })
                .then((response) => {
                    if (response.status === 200) {
                        alert('成功！');
                        this.token = response.data.token;
                        sessionStorage.setItem('accessToken', this.token);
                        sessionStorage.setItem('user_uuid', this.user_uuid);
                        // set cookies
                        const expire_day = 1;
                        const get_day = new Date();
                        get_day.setTime(get_day.getTime() + (expire_day * 24 * 60 * 60 * 1000));
                        const expires = `expires=${get_day.toGMTString()}`;
                        document.cookie = `accessToken=${this.token}; expires=${expires};`;
                        document.cookie = `user_uuid=${this.user_uuid}; expires=${expires};`;
                        // has login
                        this.not_login = false;
                        this.getUserInfo();
                    } else {
                        alert(response.data.message);
                        return false;
                    }
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        alert(error.response.data.message);
                    } else {
                        alert(`status code: ${ error.response.status }`);
                        alert(error.response.data.message);
                    }
                });
        },
        // 
        async getUserInfo() {
            await this.getUserLogin();
            if (this.token !== '' && this.user_uuid !== '') {
                this.axios({
                    method: 'post',
                    url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/get-shopmoney`,
                    headers: { 
                        Authorization: `Bearer ${this.token}`
                    },
                    data: {
                        user_uuid: this.user_uuid,
                    },
                })
                    .then((response) => {
                        this.balance = response.data.balance;
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            }
        },
        UseMoneyCoupon() {
            if (this.money_coupon === '') {
                alert('未輸入購物金序號');
            } else {
                this.axios({
                    method: 'post',
                    url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/import-shopmoney`,
                    headers: { 
                        Authorization: `Bearer ${this.token}`
                    },
                    data: {
                        user_uuid: this.user_uuid,
                        coupon: this.money_coupon
                    },
                })
                    .then((response) => {
                        this.balance = response.data.balance;
                        this.money_coupon = '';
                        alert(response.data.message);
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            }
        }
    },
    created() {
    },
    mounted() {
        this.getUserInfo();
    },
    watch: {
    },
};
</script>

<style scoped>
    /* div,span,區塊 */
    html,body,
    h1,h2,h3,h4,h5,h6,/*標題大->小*/
    p,pre,/*段落*/
    b,strong,/*粗體;一般、強調的*/
    i,em,/*斜體;一般、強調的*/
    mark,/*標記文字(預設是黃底)*/
    del,/*刪除線*/
    ins,/*底線*/
    small,/*小文字*/
    sub,/*下標文字*/
    sup,/*上標文字*/
    q,/*引號*/
    q,/*引號*/
    kbd,/*提示瀏覽者鍵盤輸入指示*/
    blockquote,/*縮排*/
    abbr,/*解釋縮寫意思;值title="World Health Organization"給瀏覽器有用信息*/
    address,/*標示地址*/
    cite,/*預設斜體*/
    bdo,/*文字方向鏡射;值dir="rtl"*/
    a,/*連結;值link(默認)、visited(未訪問)、hover(滑鼠移過去)、active(活動)*/
    img,/*圖*/
    table,caption,tr,th,td,thead,tbody,tfoot,colgroup,col,/*表格*/
    ul,ol,li,/*無序列表框;值disc(實體圈)circle(空心圈)square(實體方)none(無)、有序列表框;type=(1AaIi)、列表*/
    dl,dt,dd,/*描述列表框、描述列表裡的大標、每項大標裡的內容*/
    iframe,/*外連框架*/
    header,footer,nav,section,article,aside,details,summary,/*框架：頁頭、頁尾、連結容器、分段內容、獨立的內容、輔助內容、細節、大綱*/
    form,input,textarea,label,fieldset,legend,select,optgroup,option,button,datalist,keygen,output/*表單；input值：text文字、password密碼、submit提交、reset重設、radio單選按鈕、checkbox複選框、color色彩、email電子郵件、tel電話、url網址、number數字(可另設定max.min)、search搜索、range滑塊控制、date日期(可另設定max.min)、datetime-local日期時間、month月份、time時間、week週*/
    {
        margin: 0px;
        padding: 0px;
        border: 0;
        list-style: none;
        text-decoration: none;
        letter-spacing: 1px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        word-break: normal;
        word-wrap: break-word;
        font-family: 'Noto Sans TC', 'Microsoft JhengHei';
        color: #352d40;
    }
    body{
        font-weight: 300;
        font-size: 16px;
        min-width: 310px;
        width: auto;
        min-height: 100vh;
    }
    h1,h2,h3,h4,b,strong{
        font-weight: 500;
    }
    a{
        display: inline-block;
        font-size: 15px;
    }
    hr{
        margin:30px 0;
        border:0;
        border-bottom:1px solid #C4C4C4
    }
    .txt {
        margin-bottom: 10px;
    }
    .txt:last-type{
        margin-bottom: 0;
    }
    .txt>span{
        display: inline-block;
        color: inherit;
    }
    @media screen and (max-width:375px){
        .hide{
            display: none;
        }
    }
    @media screen and (min-width:375px){
        .hide{
            color:inherit;
        }
    }
    /*-------Flex切割--------*/
    .FlexJCSB{
        display: flex;
        justify-content: space-between;
        }
    .FlexJCC{
        display: flex;
        justify-content:center;
    }
    .FlexAIC{
        align-items: center;
    }
    .FlexAIS{
        align-items:stretch;
    }
    .FlexWrap{
        flex-flow: wrap;
    }
    /*-------文字位置--------*/
    .TextAC{
        text-align: center;
    }
    .TextAL{
        text-align: left;
    }
    .TextAR{
        text-align: right;
    }
    /*-------文字設定--------*/
    .TextSA{
        font-size: 13px;
        font-weight: 500;
        line-height: 120%;
    }
    .TextSB{
        font-size: 15px;
        font-weight: 500;
        line-height: 120%;
    }
    .TextSC{
        font-size: 18px;
        font-weight: 500;
        line-height: 120%;
    }
    .TextSD{
        font-size: 20px;
        font-weight: 500;
        line-height: 120%;
    }
    /*-------按鈕樣式--------*/
    .ButtonBox{
        padding: 15px 0;
    }
    .Button{
        padding: 7px 20px;
        -webkit-border-radius: 100px;
        -moz-border-radius: 100px;
        border-radius: 100px;
        margin: 4px 2px;
        width: max-content;
    }
    .BCFCA{/*按鈕*/
        background-color: #FF781E;
        color: #ffffff;
    }
    .BCFCB{/*按鈕*/
        background-color: #352D40;
        color:#D2DDF0;
    }
    /*-------圖片設定--------*/
    .ImgA{
        overflow: hidden;
    }
    .ImgA .Transverse{/*橫*/
        width: auto;
        height: 100%;
    }
    .ImgA .Straight{/*直*/
        width: 100%;
        height: auto;
    }
    .NameA{/*產品名稱*/
        font-size: 18px;
        line-height: 120%;
        margin: 5px 0;
    }
    .SpecA{/*產品規格*/
        font-size: 15px;
        line-height: 120%;
        margin: 5px 0;
    }
    .PriceA{/*產品價格*/
        font-size: 18px;
        line-height: 120%;
        margin: 5px 0;
    }
    .PriceA strong{/*產品價格*/
        color:#FF781E;
    }
    .PriceA del{/*產品價格*/
        font-size: 13px;
        font-weight: 300;
        text-decoration: line-through;
    }
    .labelA{/*標籤*/
        position: absolute;
        top: 5px;
        left: 0;
    }
    .labelA li{
        clip-path: polygon(100% 0%, 90% 50%, 100% 100%, 0 100%, 0 0);
        padding: 5px 18px 5px 10px;
        margin: 2px 0;
        font-size: 13px;
    }
    /*-------最上方敘述目前位置的區塊--------*/
    .Location{
        height: 62px;
        box-shadow: 0px 0 20px 0 rgba(53, 45, 64, 0.2);
    }
    .Location li{
        width:100%;
    }
    .Location li:nth-child(1){
        text-align: left;
    }
    .Location li:nth-child(1) .Button{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        margin-left: 0;
        padding: 7px 15px 7px 10px;
    }
    .Location li:nth-child(1),
    .Location li:nth-child(3){
        flex: 1;
    }
    .Location li:nth-child(2){
        text-align: center;
        flex: 2;
    }
    .Location li:nth-child(3){
        text-align: right;
    }
    .Location li:nth-child(3) .Button{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        margin-right: 0;
        padding: 7px 10px 7px 15px;
    }
    /*-------滿版圖片--------*/
    .FillImage {
        width: 100%;
    }
    .FillImage img{
        width: 100%;
        height: 100%;
        max-height: 524px;
        max-width: fit-content;
        display: block;
        margin: 0 auto;
    }
    /*-------頁面內容區塊--------*/
    .ActivitySA {
        margin-top:20px;
    }
    .ActivitySA .big{
        width: 216px;
        height: 105px;
    }
    .ActivitySA .sm{
        width: 75px;
        height: 52px;
    }
    .ActivitySA img{
        width: 100%;
        display: block;
    }
    .OrderCompleted{/*訂單完成頁*/
        margin: 0 30px;
    }
    .OrderCompleted>.ImgA{
        margin:40px 0 10px 0;
    }
    .OrderCompleted>.FocusStyle{
        border: 1px solid #FF781E;
        padding: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        color: #FF781E;
        margin: 5px 0;
    }
    .ProductList{
        width: 100%;
        max-width: 1081px;
        padding: 20px 10px;
    }
    .ProductList>li{
        position: relative;
        margin: 5px;
        width: calc(100% / 2 - 10px);
    }
    .ProLiStyle .ImgA{
        width: calc(50vw - 20px);
        height: calc(50vw - 20px);
    }
    .ProLiStyle .NameA{
        margin-top: 10px;
    }
    /*-------form樣式---------*/
    .FormBox input{
        width: 100%;
        padding: 8px;
        border-radius: 5px;
        border: 1px solid #bdbdbd;
    }
    .FormBox input[type=button]{
        width: auto;
        padding: 8px;
        border-radius: 5px;
        border: 1px solid #352D40;
        background-color: #352D40;
        color:#D2DDF0;
        flex: auto;
    }
    .FormBox > *{
        margin-right: 5px;
    }
    .FormBox > *:last-child,
    .FormBox > *:only-child{
        margin-right: 0;
    }
    /*-------底色定義--------*/
    .BCA{
        background-color: #FDD35C;
    }
    .BCB{
        background-color: #FFCC33;
    }
    .BCC{
        background-color: #D2DDF0;
    }
</style>
